import { render, staticRenderFns } from "./ListItemOptionAttachmentType.vue?vue&type=template&id=4fb9ae25&scoped=true&"
import script from "./ListItemOptionAttachmentType.vue?vue&type=script&lang=js&"
export * from "./ListItemOptionAttachmentType.vue?vue&type=script&lang=js&"
import style0 from "./ListItemOptionAttachmentType.vue?vue&type=style&index=0&id=4fb9ae25&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb9ae25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb9ae25')) {
      api.createRecord('4fb9ae25', component.options)
    } else {
      api.reload('4fb9ae25', component.options)
    }
    module.hot.accept("./ListItemOptionAttachmentType.vue?vue&type=template&id=4fb9ae25&scoped=true&", function () {
      api.rerender('4fb9ae25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/tools/components/ListItemOptionAttachmentType.vue"
export default component.exports